export const LocalForageKeys = {
  auth: {
    AccessToken: "80329cb67928b97d1fa857790f70f0fc",
    RefreshToken: "95817060051575189ffb2d2381595874",
    urlRedirectToAfterLogin: "6b9250c67ebc5679248053f15713ce0b",
  },
} as const;
